// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import * as React from "react";
import {
  PlasmicTable,
  DefaultTableProps
} from "./plasmic/my_evals_marketing/PlasmicTable";
import { HTMLElementRefOf } from "@plasmicapp/react-web";

// Your component props start with props for variants and slots you defined
// in Plasmic, but you can add more here, like event handlers that you can
// attach to named nodes in your component.
//
// If you don't want to expose certain variants or slots as a prop, you can use
// Omit to hide them:
//
// interface TableProps extends Omit<DefaultTableProps, "hideProps1"|"hideProp2"> {
//   // etc.
// }
//
// You can also stop extending from DefaultTableProps altogether and have
// total control over the props for your component.
export interface TableProps extends DefaultTableProps {}

function Table_(props: TableProps, ref: HTMLElementRefOf<"div">) {
  // Use PlasmicTable to render this component as it was
  // designed in Plasmic, by activating the appropriate variants,
  // attaching the appropriate event handlers, etc.  You
  // can also install whatever React hooks you need here to manage state or
  // fetch data.
  //
  // Props you can pass into PlasmicTable are:
  // 1. Variants you want to activate,
  // 2. Contents for slots you want to fill,
  // 3. Overrides for any named node in the component to attach behavior and data,
  // 4. Props to set on the root node.
  //
  // By default, we are just piping all TableProps here, but feel free
  // to do whatever works for you.

  return <PlasmicTable table={{ ref }} {...props} />;
}

const Table = React.forwardRef(Table_);
export default Table;
